import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="flex justify-center py-24" data-testid="auth-loading">
        <Loader2 className="h-8 w-8 animate-spin" />
      </div>
    );
  if (!user) return <Navigate to="/docente/login" replace />;
  return children;
};
